const useMapEventLogger = () => {
    const logMapEvent = (event, data) => {
        console.log(`[Map Event] ${event}:`, data);
    };

    return logMapEvent;
};

export default useMapEventLogger; 